module.exports = __webpack_public_path__ + "img/qihuoshangpin_foot.d715abd8.png";